import { render } from "./Accidents.vue?vue&type=template&id=7300e1d7&scoped=true"
import script from "./Accidents.vue?vue&type=script&lang=js"
export * from "./Accidents.vue?vue&type=script&lang=js"

import "./Accidents.vue?vue&type=style&index=0&id=7300e1d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7300e1d7"]])

export default __exports__